function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

module.exports = _iterableToArray;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@babel_runtime@7.7.2@@babel/runtime/helpers/iterableToArray.js
// module id = 299
// module chunks = 0 1 2